import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import FileSample from "../../assets/img/Vector.png";
import { saveAs } from "file-saver";

const ExportCsv = ({ tableData, resourceType }) => {
  const { t } = useTranslation();

  const handleExport = async () => {
    if (!tableData || tableData.length === 0) return;

    const { default: ExcelJS } = await import("exceljs");

    const processedData = tableData.map((row) => {
      const newRow = {};
      for (const key in row) {
        const value = row[key];
        if (Array.isArray(value)) {
          newRow[key] = value.join(", ");
        } else {
          newRow[key] = value;
        }
      }
      return newRow;
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Datos");
    const headers = Object.keys(processedData[0] || {});

    if (headers.length > 0) {
      worksheet.columns = headers.map((header) => ({
        header,
        key: header,
      }));
      processedData.forEach((row) => {
        worksheet.addRow(row);
      });
    }

    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0];
    const fileName = `${resourceType}_${formattedDate}.xlsx`;

    const excelBuffer = await workbook.xlsx.writeBuffer();
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, fileName);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<img src={FileSample} alt="Funnel" className="file" />}
      onClick={handleExport}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        padding: "8px 16px",
        borderRadius: "4px",
        backgroundColor: "var(--main-color)",
        color: "primary.contrastText",
        textTransform: "none",
        fontSize: "1rem",
        fontWeight: "400",
        lineHeight: "1.5",
        height: "45px",
      }}
    >
      {t("privateArea.actionLog.exportCSV")}
    </Button>
  );
};

export default ExportCsv;
